import React from 'react';
import { Routes, Route, Navigate, Link, useLocation } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Button,
  Box
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  SmartToy as AIIcon,
  SoupKitchen as KitchenIcon
} from '@mui/icons-material';
import Dashboard from './components/Dashboard';
import AIAssistant from './components/AIAssistant';
import KitchenDisplay from './components/KitchenDisplay';

function NavButton({ to, label, icon }: { to: string; label: string; icon: React.ReactNode }) {
  const location = useLocation();
  const isActive = location.pathname === to;
  return (
    <Button
      color={isActive ? 'inherit' : 'inherit'}
      component={Link}
      to={to}
      variant={isActive ? 'outlined' : 'text'}
      startIcon={icon}
      sx={{ ml: 1 }}
    >
      {label}
    </Button>
  );
}

function App() {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Sabal Operations
          </Typography>
          <NavButton to="/" label="Dashboard" icon={<DashboardIcon />} />
          <NavButton to="/ai" label="AI Assistant" icon={<AIIcon />} />
          <NavButton to="/kitchen" label="Kitchen" icon={<KitchenIcon />} />
        </Toolbar>
      </AppBar>
      <Container sx={{ py: 3, flexGrow: 1 }}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/ai" element={<AIAssistant />} />
          <Route path="/kitchen" element={<KitchenDisplay />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Container>
    </Box>
  );
}

export default App;
